import React, {useContext} from "react"
import {Panel, DataRow} from "../../PDFPrimitives"
import {PDFContext} from "../../BasePDF"

export const PurchaseDealerPriceBreakdownPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Price Breakdown">
            <DataRow label="Vehicle Cost"   value={pdfData.vehicle_cost.toDollarFormat()}/>
            <DataRow label="Vehicle Profit" value={pdfData.vehicle_profit.toDollarFormat()} variant="muted"/>
            <DataRow
                label="Total Cash Price"
                value={pdfData.total_cash_price.toDollarFormat()}
                isTotal
                variant="bold"
                isLast
            />
        </Panel>
    )
}
